import type { BaseRequest, TableConfig } from "../../../types/tables";

import { createActionsColumn } from "../../helpers/actionsColumn";
import {
  brandCell,
  createdByCell,
  dateCell,
  nameCell,
  requestDesignTypeCell,
} from "../../helpers/commonCells";

export const archivedTableConfig: TableConfig<BaseRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 260,
    },
    {
      accessor: "brand",
      cellRenderer: brandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: 200,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: 140,
    },
    {
      accessor: "requestType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "requestType",
      sortable: true,
      width: 180,
    },
    createActionsColumn<BaseRequest>(["duplicate", "copyLink"]),
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  enableSorting: true,
  id: "archived-requests",
  title: "Archived Requests",
};
